import { Authentication } from '@leedpulse-monorepo/classes';
import Failure from '../../../core/Failure';
import HttpClient from '../../../core/HttpClient';

export interface ProvisionCrmUserPayload {
  companyId: string;
  userId: string;
  email: string;
  firstname?: string;
  lastname?: string;
  phone?: string;
}

export interface ProvisionCrmUserResponse {
  success: boolean;
  data?: { uid: string; created: boolean };
}

export class ProvisionCrmUserFailure extends Failure {
  constructor(message = 'Unknown error', code = 'provision-crm-user-failure') {
    super(message, code);
  }
}

async function provisionCrmUser(
  payload: ProvisionCrmUserPayload,
  authentication: Authentication
): Promise<ProvisionCrmUserResponse> {
  try {
    const { companyId, ...body } = payload;
    return await HttpClient.post(
      `/integrations/companies/${companyId}/users`,
      body,
      authentication.token
    );
  } catch (e) {
    throw new ProvisionCrmUserFailure((e as Error).message);
  }
}

export default provisionCrmUser;
